import events from 'events';
import { NotificationSubType } from 'redux/notification/types';

import { UPLOAD_FILE } from '../constants/file';

export const notifyEvent = new events.EventEmitter();

export const checkRealtimeUpdate = (subType: NotificationSubType | undefined): boolean =>
  subType === NotificationSubType.APPOINTMENT_ASSIGNED ||
  subType === NotificationSubType.APPOINTMENT_REJECTED ||
  subType === NotificationSubType.APPOINTMENT_APPROVED;

export const uploadFileProgressEvent = new events.EventEmitter();

export const emitUploadFileEvent = (data: any) => {
  uploadFileProgressEvent.emit(UPLOAD_FILE, data);
};
